const config = {
    network: {
        layer1: 'placeholder',
    },
    logLevel: 'debug',
};
export { config };
//# sourceMappingURL=config.js.map